import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { addStudentsToWaitlist } from '../../../../../actions/waitlistActions'
import { setIsJoinedModalOpen, setIsWaitlistModalOpen } from '../../../../../reducers/programPresentationReducer'
import { COMMON_ERRORS } from '../../../../../misc/Constants'

const useJoinWaitlist = () => {
  const dispatch = useDispatch()
  const course = useSelector(state => state.programPresentation.course)
  const currentUser = useSelector(state => state.user.current_user)

  // TODO: Error messages from BE
  const handleAddStudentsToWaitlist = (students) => {
    dispatch(addStudentsToWaitlist({ course, students }))
      .unwrap()
      .then(() => dispatch(setIsJoinedModalOpen(true)))
      .catch((err) => toast.error(err?.status === 403 ? COMMON_ERRORS[403] : COMMON_ERRORS[500], { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => dispatch(setIsWaitlistModalOpen(false)))
  }

  const handleJoinButtonClick = () => {
    if (!currentUser) { return }

    const notTheOnlyFamilyMember = currentUser.family?.users && currentUser.family.users.length > 1

    if (currentUser.family_admin && notTheOnlyFamilyMember) {
      dispatch(setIsWaitlistModalOpen(true))
    } else {
      handleAddStudentsToWaitlist([currentUser.id])
    }
  }

  return { handleJoinButtonClick, handleAddStudentsToWaitlist }
}

export default useJoinWaitlist
